export const joinItemsWithBullet = items => (items || []).join('\n\u2022 ');

export const stripHtmlTags = string => (string || '').replace(/<[^>]+>/giu, '');
